module.exports = __webpack_public_path__ + "img/flipkart.a6c6989d.png";